/**
 * 
 * @author Tim
 * @date 2024-01-04
 */

/**
 * 获取小程序账号信息
 * @returns {Object} 包含账号信息、AppID 和版本号的对象
 */
export function getAccountInfoSync() {
	let accountInfo;






	accountInfo = {
		miniProgram: {
			appId: '',
			version: '1.0.0'
		}
	};


	const {
		appId,
		version
	} = accountInfo.miniProgram;

	return {
		accountInfo,
		appId,
		version,
	};
}

/**
 * 获取系统信息
 * @returns {Object} 包含系统信息的对象
 */
export function getSystemInfoSync() {
	return uni.getSystemInfoSync();
}

/**
 * 获取状态栏信息
 */
export function getNavBarInfo() {
	let statusBar = 0
	let customBar = 0
	let navBar = 0
	let safeAreaInsets = 0
	uni.getSystemInfo({
		success: (e,any) => {



























			statusBar = 0
			customBar = e.statusBarHeight + 45

			
			navBar = customBar - statusBar
			safeAreaInsets = e.safeAreaInsets
		}
	})
	
	return {
		'statusBar':statusBar,
		'customBar':customBar,
		'navBar':navBar,
		'safeAreaInsets':safeAreaInsets
	}
}

/**
 * 获取当前编辑器选中的小程序名称和配置
 * @returns {Object} 包含编译模式代码和标题的对象
 */
export function getCurrentAppMode() {
	let mode = {
		code: '',
		title: '',
		platform: '',
		env: {}
	};
	
	// 尝试从 process.env 获取当前选中的脚本名称
	if (process.env) {
		// 记录环境变量
		mode.env = { ...process.env };
		
		if (process.env.UNI_SCRIPT) {
			const scriptName = process.env.UNI_SCRIPT;
			mode.code = scriptName;
			
			// 获取 package.json 中对应脚本的配置
			try {
				const packageInfo = require('../package.json');
				if (packageInfo && packageInfo['uni-app'] && packageInfo['uni-app'].scripts && packageInfo['uni-app'].scripts[scriptName]) {
					const scriptConfig = packageInfo['uni-app'].scripts[scriptName];
					mode.title = scriptConfig.title || scriptName;
					
					// 记录平台信息
					if (scriptConfig.env && scriptConfig.env.UNI_PLATFORM) {
						mode.platform = scriptConfig.env.UNI_PLATFORM;
					}
				}
			} catch (error) {
				console.error('[appInfo] Error reading package.json:', error);
			}
		}
		
		// 如果没有从package.json获取到平台信息，则尝试从环境变量获取
		if (!mode.platform && process.env.UNI_PLATFORM) {
			mode.platform = process.env.UNI_PLATFORM;
		}
	}
	
	// 如果无法从环境变量获取，则使用条件编译
	if (!mode.code) {




		




	}
	
	return mode;
}